if (!customElements.get('cl-product-information-tabs')) {
  customElements.define(
    'cl-product-information-tabs',
    class CLProductInformationTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-product-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-product-tab-panel]'));

        if (!this.tabs.length || !this.panels.length) return;

        this.handleTabClick = this.onTabClick.bind(this);
        this.handleTabKeydown = this.onTabKeydown.bind(this);
        this.handleBlockSelect = this.onBlockSelect.bind(this);

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', this.handleTabClick);
          tab.addEventListener('keydown', this.handleTabKeydown);
        });

        document.addEventListener('shopify:block:select', this.handleBlockSelect);

        const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
        this.activateTab(selectedTab, false);
      }

      disconnectedCallback() {
        this.tabs?.forEach((tab) => {
          tab.removeEventListener('click', this.handleTabClick);
          tab.removeEventListener('keydown', this.handleTabKeydown);
        });
        if (this.handleBlockSelect) {
          document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        }
      }

      onTabClick(event) {
        this.activateTab(event.currentTarget, false);
      }

      onTabKeydown(event) {
        const currentIndex = this.tabs.indexOf(event.currentTarget);
        let nextIndex = currentIndex;

        switch (event.key) {
          case 'ArrowLeft':
            nextIndex = currentIndex === 0 ? this.tabs.length - 1 : currentIndex - 1;
            break;
          case 'ArrowRight':
            nextIndex = currentIndex === this.tabs.length - 1 ? 0 : currentIndex + 1;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = this.tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        this.activateTab(this.tabs[nextIndex], true);
      }

      onBlockSelect(event) {
        const selectedTab = this.tabs.find((tab) => tab.dataset.blockId === event.detail?.blockId);
        if (selectedTab) this.activateTab(selectedTab, false);
      }

      activateTab(selectedTab, moveFocus) {
        if (!selectedTab) return;

        const panelId = selectedTab.getAttribute('aria-controls');

        this.tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.classList.toggle('is-active', isSelected);
          tab.setAttribute('aria-selected', isSelected.toString());
          tab.tabIndex = isSelected ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== panelId;
        });

        if (moveFocus) selectedTab.focus();
      }
    }
  );
}
